import MilitaryHero from 'assets/images/psp/PSPHero/military-hero.webp';
import ChartOne1 from 'assets/images/psp/MilitaryIcons/MilitarySizeChartOne/iconOne.svg';
import ChartOne2 from 'assets/images/psp/MilitaryIcons/MilitarySizeChartOne/iconTwo.svg';
import ChartOne3 from 'assets/images/psp/MilitaryIcons/MilitarySizeChartOne/iconThree.svg';
import ChartOne4 from 'assets/images/psp/MilitaryIcons/MilitarySizeChartOne/iconFour.svg';
import ChartOne5 from 'assets/images/psp/MilitaryIcons/MilitarySizeChartOne/iconFive.svg';
import Charttwo1 from 'assets/images/psp/MilitaryIcons/MilitarySizeChartTwo/iconOne.svg';
import Charttwo2 from 'assets/images/psp/MilitaryIcons/MilitarySizeChartTwo/iconTwo.svg';
import Charttwo3 from 'assets/images/psp/MilitaryIcons/MilitarySizeChartTwo/iconThree.svg';
import Charttwo4 from 'assets/images/psp/MilitaryIcons/MilitarySizeChartTwo/iconFour.svg';
import Charttwo5 from 'assets/images/psp/MilitaryIcons/MilitarySizeChartTwo/iconFive.svg';
import Charttwo6 from 'assets/images/psp/MilitaryIcons/MilitarySizeChartTwo/iconSix.svg';
import Charttwo7 from 'assets/images/psp/MilitaryIcons/MilitarySizeChartTwo/iconSeven.svg';
import Charttwo8 from 'assets/images/psp/MilitaryIcons/MilitarySizeChartTwo/iconEight.svg';
import Featured1 from 'assets/images/psp/FeaturedContentImages/militaryFeatured1.png';
import Featured2 from 'assets/images/psp/FeaturedContentImages/militaryFeatured2.jpg';
import Featured3 from 'assets/images/psp/FeaturedContentImages/militaryFeatured3.jpg';
import Featured4 from 'assets/images/psp/FeaturedContentImages/militaryFeatured4.webp';
import { storageCategories } from 'pages/PSPPage/utils/getPSPLinks';

const reviews = [
	{
		title: 'Great experience',
		stars: 5,
		text: 'Great experience, professional in their presentation. We had a good experience with this company. They help us find storage for an RV at a great price, including a military/veteran discount!',
		customerName: 'Joseph R. Davis',
		date: 'Apr 8, 2023',
		link: 'https://www.trustpilot.com/reviews/64318f0e734f97e68f9a35e9',
	},
	{
		title: 'I needed a storage unit at the last minute…',
		stars: 5,
		text: "I needed a storage unit at the last minute. I went with SelfStorage.com. I'm sure glad that I did. Very friendly staff, huge selection of units, found a great location and the unit was very clean. The staff helped to meet all my needs and have great rates. I am also proud to be a patron to a business that honors our military and veterans. Thanks guys!",
		customerName: 'David Shepherd',
		date: 'Aug 1, 2022',
		link: 'https://www.trustpilot.com/reviews/62e6d3d84c35e69ec51f5056',
	},
	{
		title: 'Using the SelfStorage reservation system over the…',
		stars: 5,
		text: 'Using the SelfStorage reservation system over the internet was easy and convenient, especially no fee attached.',
		customerName: 'Ben',
		date: 'Nov 2, 2021',
		link: 'https://www.trustpilot.com/reviews/61804d1775069a4da4964aca',
	},
	{
		title: 'The reservation process was very easy	',
		stars: 5,
		text: 'The reservation process was very easy. I quickly saw what was available and closest to me. The military discount made the deal. Very pleased.',
		customerName: 'Darrell Jackson',
		date: 'Oct 13, 2020',
		link: 'https://www.trustpilot.com/reviews/5f84ab86798e6f0bcc42fd22',
	},
];

const faqs = [
	{
		question: 'Do storage facilities offer military discounts?',
		answer: 'Yes. Most facilities offer 10-20% off monthly rates for active duty military, veterans, and military spouses. Simply show your military ID, VA card, or dependent ID when you sign up. Some facilities also waive administrative fees for service members.',
	},
	{
		question: 'Can I access my military storage unit while deployed?',
		answer: 'You can authorize a family member or trusted friend to access your unit on your behalf by adding them to your rental agreement. Choose a storage unit for the military with 24-hour access for maximum flexibility during their visits.',
	},
	{
		question: "What's the best size for storing a car during deployment?",
		answer: 'A 10x10 or 10x15 unit works for most sedans and compact SUVs. For trucks or larger vehicles, opt for a 10x20. Many facilities also offer dedicated military car storage parking spaces that may be more affordable than enclosed units.',
	},
	{
		question: 'Are military storage units climate controlled?',
		answer: "Climate control is optional but recommended if you're storing uniforms, electronics, leather gear, or items sensitive to temperature and humidity. Standard large military storage containers work fine for furniture and non-delicate items in most climates.",
	},
	{
		question:
			'Can I rent a storage unit month-to-month without a long lease?',
		answer: "Most military storage units near me operate on month-to-month agreements, which is perfect for the unpredictable nature of military life. You can typically cancel with 5-10 days' notice, and many facilities prorate your final month.",
	},
	{
		question: 'How do I pack military gear and uniforms for storage?',
		answer: 'Use military storage bins or plastic containers instead of cardboard boxes to protect against moisture. Hang dress uniforms in wardrobe boxes or garment bags. Store boots and leather items with cedar blocks to prevent mildew. Create an aisle down the center of your unit so you can access items easily.',
	},
	{
		question: 'What security features should I look for?',
		answer: "Look for facilities with gated access, individual unit alarms, video surveillance, and on-site management. If you're storing a vehicle in military car storage, choose a well-lit area with controlled entry and regular patrols.",
	},
];

const whoBenefitsData = {
	title: 'Military Storage Unit Sizes & Pricing',
	description:
		'Whether you’re looking for large military storage containers or smaller military storage bins and lockers, you can find the right self storage unit size and amenities for your needs and budget.',
	contentdec:
		'**Pricing data sourced from SelfStorage.com market rates. Actual costs vary by location and availability. Many facilities offer 10-20% military discounts. Military discount information is often available on individual facility pages when you shop and reserve through our network.*',
	storageData: [
		{
			size: '5x5',
			heading: "5' wide x 5' long",
			desc: [
				'**Best for:** Military storage bins, uniforms, small gear, boxes of personal items \n \n**Average monthly cost:** $45 - $75',
			],
		},
		{
			size: '5x10',
			heading: "5' wide x 10' long",
			desc: [
				'**Best for:** Motorcycle, tactical equipment, military storage containers, seasonal items \n \n**Average monthly cost:** $70 - $110',
			],
		},
		{
			size: '10x10',
			heading: "10' wide x 10' long",
			desc: [
				'**Best for:** Military car storage (compact), furniture from a 1-bedroom apartment, appliances \n \n**Average monthly cost:** $95 - $165',
			],
		},
		{
			size: '10x15',
			heading: "10' wide x 15' long",
			desc: [
				'**Best for:** Contents of a 2-bedroom home, SUV or truck, and large military storage containers \n \n**Average monthly cost:** $135 - $210',
			],
		},
		{
			size: '10x20',
			heading: "10' wide x 20' long",
			desc: [
				'**Best for:** 3-bedroom household, military car storage plus furniture, boat \n \n**Average monthly cost:** $160 - $250',
			],
		},
		{
			size: '10x30',
			heading: "10' wide x 30' long",
			desc: [
				'**Best for:** Entire 4-bedroom home, multiple vehicles, RV storage \n \n**Average monthly cost:** $225 - $350',
			],
		},
	],
};

export const MilitaryContent = {
	type: 'Military',
	reviews: reviews,
	sections: [
		{
			title: 'Military Storage Hero',
			background: 'default',
			modules: [
				{
					type: 'hero',
					id: 'military-storage-hero',
					props: {
						content: {
							title: 'Find Affordable Military Self Storage ',
							image: MilitaryHero,
							description:
								"Military life means constant change. Base housing changes and short-notice deployments are common, bringing logistical chaos along with them. For active duty personnel, veterans, and their families, finding [reliable storage units for military belongings](https://www.selfstorage.com/blog/military-storage-for-families/) shouldn't add to your stress.\n\nThat's where specialized military storage comes in. Find month-to-month flexibility, shop military discounts, and secure military self storage near major bases nationwide with **SelfStorage.com**.",
							CTAtext: 'Find Military Self Storage',
							storageType: 'Military Storage',
						},
					},
				},
			],
		},
		{
			title: 'Size Chart 1',
			noPaddingBottom: true,
			modules: [
				{
					type: 'cardStrip',
					props: {
						heading: '5 Ways to Use Storage Units for the Military',
						cardData: [
							{
								title: 'Vehicle Storage During Deployment',
								content:
									"[Military car storage keeps your vehicle safe](https://www.selfstorage.com/blog/how-to-store-a-car/) and maintained while you're overseas. Many facilities offer covered or enclosed parking spaces, battery maintenance, and regular check-ins. Got more than one car, maybe a boat, or an ATV? We can find storage for all your vehicles and more.",
								imageSrc: ChartOne1,
								contentAlign: 'text-left',
							},
							{
								title: 'PCS Moves & Relocations',
								content:
									"When orders come through but your new housing isn't ready, military storage bins and self storage units bridge the gap. Store your furniture, clothing, and household items for a few weeks or months until you can move in.",
								imageSrc: ChartOne2,
								contentAlign: 'text-left',
							},
							{
								title: 'Downsizing from On-Base to Off-Base Housing',
								content:
									"Moving from a spacious on-base home to a smaller off-base apartment? Keep seasonal items, extra furniture, and kids' toys in a nearby unit instead of cramping your new space.",
								imageSrc: ChartOne3,
								contentAlign: 'text-left',
							},
							{
								title: 'Training Exercises & Extended TDY',
								content:
									'For National Guard members and reservists who travel frequently for training, military storage bins provide a home for gear between exercises without taking over your garage.',
								imageSrc: ChartOne4,
								contentAlign: 'text-left',
							},
							{
								title: 'College Storage for Military Dependents',
								content:
									'Military kids attending college can use storage during summer break or study abroad semesters, especially when families relocate to a new duty station mid-semester.',
								imageSrc: ChartOne5,
								contentAlign: 'text-left',
							},
						],
					},
				},
			],
		},
		{
			title: 'Military Storage Unit Sizes & Pricing',
			noPaddingBottom: true,
			modules: [
				{
					type: 'sizeComparisonSection',
					props: {
						content: {
							title: whoBenefitsData.title,
							description: whoBenefitsData.description,
							image: whoBenefitsData.image,
							contentdec: whoBenefitsData.contentdec,
						},
						storageData: whoBenefitsData.storageData,
					},
				},
			],
		},
		{
			title: 'Size Chart 2 ',
			modules: [
				{
					type: 'cardStrip',
					props: {
						heading:
							'What Amenities Can I Find in Storage Units for Military Members & Their Families?',
						description:
							"Understanding what amenities are available can help you choose the right facility for your needs. Here's what to look for when comparing storage units for military personnel:",
						cardData: [
							{
								title: 'Security Features',
								content:
									'Gated access, cameras, individual unit alarms, on-site management',
								imageSrc: Charttwo1,
								contentAlign: 'text-left',
							},
							{
								title: 'Month-to-Month Rental',
								content:
									'No long-term commitment; cancel with short notice when orders change',
								imageSrc: Charttwo2,
								contentAlign: 'text-left',
							},
							{
								title: '24-Hour Access',
								content:
									'Family can retrieve items anytime, especially important across time zones',
								imageSrc: Charttwo3,
								contentAlign: 'text-left',
							},
							{
								title: 'Climate Control',
								content:
									'Protects uniforms, electronics, and leather gear from humidity and temperature extremes',
								imageSrc: Charttwo4,
								contentAlign: 'text-left',
							},
							{
								title: 'Vehicle/RV Parking',
								content:
									'Covered or enclosed military car storage spaces for POVs during deployment',
								imageSrc: Charttwo5,
								contentAlign: 'text-left',
							},
							{
								title: 'Online Payments',
								content:
									"Set up autopay so rent is covered while you're deployed without late fees",
								imageSrc: Charttwo6,
								contentAlign: 'text-left',
							},
							{
								title: 'Gate Access for Authorized Users',
								content:
									"Add spouse or family member to account for access while you're away",
								imageSrc: Charttwo7,
								contentAlign: 'text-left',
							},
							{
								title: 'Online Move-In',
								content:
									'Not only can you reserve any storage unit in our network online, but many facilities are now offering online move-ins.Reserve and complete rental paperwork remotely—perfect when you receive sudden orders.',
								imageSrc: Charttwo8,
								contentAlign: 'text-left',
							},
						],
					},
				},
			],
		},
		{
			title: 'Reviews Section',
			background: 'lighterBlue',
			modules: [
				{
					type: 'reviews',
					props: {
						reviewsData: {
							reviews,
							headerTitle: 'Military Self Storage: ',
						},
					},
				},
			],
		},
		{
			title: 'Faqs Section',
			modules: [
				{
					type: 'faqs',
					props: {
						content: {
							header: 'Military Self Storage FAQs',
							faqs,
						},
					},
				},
			],
		},
		{
			title: 'featured content',
			background: 'darkBlue',
			modules: [
				{
					type: 'featuredContent',
					props: {
						data: {
							heading: 'Learn All About Military Self Storage',
							data: {
								unitCards: [
									{
										title: 'Storage Tips',
										url: 'https://www.selfstorage.com/blog/best-storage-units-for-military/',
										date: 'October 17, 2025',
										image: Featured1,
										content:
											'Top Amenities for Military Storage ',
									},
									{
										title: 'Storage Tips',
										url: 'https://www.selfstorage.com/blog/military-storage-for-families/',
										date: 'October 17, 2025',
										image: Featured2,
										content:
											'Military Storage Solutions for Families: Keeping Your Home Organized During Relocations',
									},
									{
										title: 'Storage Tips',
										url: 'https://www.selfstorage.com/blog/storage-units-military-discount/',
										date: 'October 17, 2025',
										image: Featured3,
										content:
											'A Guide to Military Discounts & Storage Solutions for Service Members',
									},
									{
										title: 'Storage Tips',
										url: 'https://www.selfstorage.com/blog/self-storage-unit-size-guide-2/',
										date: 'October 16, 2025',
										image: Featured4,
										content:
											'The Ultimate Storage Unit Size Guide: Finding the Perfect Fit for Your Storage Needs',
									},
								],
							},
						},
					},
				},
			],
		},
		{
			title: 'Link to other PSPs',
			background: 'lighterBlue',
			modules: [
				{
					type: 'links',
					props: {
						heading: {
							headingName: 'More ways to store',
						},
						linksList: storageCategories.military,
					},
				},
			],
		},
		{
			title: 'nearby units',
			modules: [
				{
					type: 'storageNearYou',
					props: {
						type: 'Military',
					},
				},
			],
		},
	],
	storageType: 'Military',
};
